<template>
  <div class="form-group" :class="{ 'has-error': invalid }">
    <label class="trip-label">{{ campos.label }}:</label>
    <i :class="campos.iconClass"></i>
    <button
      class="btn btn-success btn-add-pin"
      type="button"
      data-toggle="tooltip"
      title="Adicionar um local de passagem"
      @click="$emit('addPoint')"
      v-if="sequence == 0"
    >
      <i class="icon icon-plus"></i>
    </button>
    <button
      class="btn btn-danger btn-del-pin"
      type="button"
      data-toggle="tooltip"
      title="Remover local de passagem"
      @click="$emit('removePoint', sequence)"
      v-else-if="sequence != totalPoints - 1"
    >
      <i class="icon icon-minus"></i>
    </button>
    <input
      :class="campos.inputClass"
      :name="id"
      :id="id"
      :placeholder="campos.placeholder"
      ref="input"
      v-model="model"
    />
    <!-- <div class="help-block" v-if="invalid">
      Selecione um item na lista de sugestões.
    </div> -->
  </div>
</template>
<style scoped lang="scss">
.route-label-input {
  float: left;
  height: 25px !important;
  margin: 0 5px !important;
  padding: 6px !important;
  width: 80px !important;
}
.trip-label {
  font-weight: bold;
  width: 100%;
}
.has-error .help-block {
  margin-left: 32px;
}
.pin-origin {
  background: url("../../../assets/img/pins/pin-origin.svg") center left
    no-repeat;
  float: left;
  height: 32px;
  width: 32px;
}
.pin-waypoint {
  background: url("../../../assets/img/pins/pin-waypoint.svg") center left
    no-repeat;
  float: left;
  height: 32px;
  width: 32px;
}
.pin-destination {
  background: url("../../../assets/img/pins/pin-destination.svg") center left
    no-repeat;
  float: left;
  height: 32px;
  width: 32px;
}
.btn-add-pin,
.btn-add-pin:active .btn-add-pin:focus,
.btn-add-pin:hover,
.btn-del-pin,
.btn-del-pin:active .btn-del-pin:focus,
.btn-del-pin:hover {
  float: right;
  font-size: 1.2em !important;
  padding: 8px !important;
}
.input-origin {
  width: calc(100% - 72px);
}
.input-destination {
  width: calc(100% - 32px);
}
</style>
<script>
import MapLoader from "google-maps";
export default {
  props: ["totalPoints", "initLocation", "sequence", "type"],
  data() {
    return {
      id: "ac" + new Date().getTime(),
      ac: {},
      location: this.initLocation,
      model: undefined,
    };
  },
  computed: {
    campos() {
      if (this.sequence == 0)
        return {
          label: "Origem",
          placeholder: "Digite um local de origem",
          iconClass: "pin-origin",
          inputClass: "form-control input-origin",
        };
      else if (this.sequence == this.totalPoints - 1)
        return {
          label: "Destino",
          placeholder: "Digite um local de destino",
          iconClass: "pin-destination",
          inputClass: "form-control input-destination",
        };
      else
        return {
          label: "Passagem " + this.sequence,
          placeholder: "Digite um local de passagem",
          iconClass: "pin-waypoint",
          inputClass: "form-control input-origin",
        };
    },
    invalid() {
      return (
        this.location &&
        this.formatAddressMM(this.location.address) !=
          this.formatAddressMM(this.model)
      );
    },
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
    this.location.sequence = this.sequence + 1;
    let vm = this;
    let options = {
      //types: ['geocode'],
      //componentRestrictions: {country: 'br'},
      strictBounds: true,
      bounds: this.restriction,
      suppressMarkers: true,
    };
    vm.model = this.location && this.location.address;
    MapLoader.KEY = "AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE";
    MapLoader.LIBRARIES = ["places"];
    MapLoader.load(function (google) {
      vm.ac = new google.maps.places.Autocomplete(vm.$refs.input, options);
      google.maps.event.addListener(vm.ac, "place_changed", function () {
        vm.model = vm.formatAddressMM(vm.ac.getPlace().formatted_address);
        vm.location = vm.placeToPointLocation(vm.ac.getPlace());
      });
    });
  },
  watch: {
    initLocation(newVal) {
      this.location = newVal;
      this.model = this.location && this.location.address;
    },
    model() {
      this.$emit("placeChanged");
    },
    sequence() {
      this.location.sequence = this.sequence + 1;
    },
  },
  methods: {
    /* Por algum motivo bizarro o goole nao consegue calcular a rota informando "Guararema, SP, 08900-000, Brasil", esse funcao remove o CEP de cidades com CEP unico
     */
    formatAddressMM(a) {
      if (a) return a.replace(/[0-9]{5}-000,/, "");
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (
          this.model &&
          this.location &&
          this.formatAddressMM(this.location.address) ==
            this.formatAddressMM(this.model)
        )
          resolve(true);

        reject(false);
      });
    },
    placeToPointLocation(place) {
      let vm = this;
      let p = this.location;
      _.each(place.address_components, function (o) {
        if (_.indexOf(o.types, "postal_code") >= 0)
          p.zipCode = o.short_name.replace(/[^0-9]/g, "");
        else if (_.indexOf(o.types, "administrative_area_level_1") >= 0)
          p.state = o.short_name;
        else if (_.indexOf(o.types, "administrative_area_level_2") >= 0)
          p.city = o.short_name;
        else if (_.indexOf(o.types, "sublocality") >= 0)
          p.neighborhood = o.short_name;
        else if (_.indexOf(o.types, "route") >= 0) p.address = o.short_name;
        else if (_.indexOf(o.types, "street_number") >= 0)
          p.number = o.short_name;
        else if (_.indexOf(o.types, "country") >= 0) p.country = o.short_name;
      });
      try {
        p.address = this.formatAddressMM(place.formatted_address);
        p.lat = place.geometry.location.lat();
        p.lng = place.geometry.location.lng();
      } catch (err) {}
      return p;
    },
  },
};
</script>



// WEBPACK FOOTER //
// input-google-ac.vue?284db4da